<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
             <a-form-item :label="$t('label.farms')">
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectFarms')" v-model="queryParam.farmCode" dictCode="sys_depart,depart_name,org_code,org_category='5' and del_flag='0'"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.feedingLot')">
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectTheFeedingLot')" v-model="queryParam.breedBatchCode" dictCode="efs_md_breed_batch,name,code"/>
            </a-form-item>
          </a-col>
          <!--<template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="是否有效">
                <j-dict-select-tag placeholder="请选择是否有效" v-model="queryParam.validFlag" dictCode="sfyx"/>
              </a-form-item>
            </a-col>
          </template>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
<!--      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>-->
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
<!--        <a-menu slot="overlay">-->
<!--          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>-->
<!--        </a-menu>-->
<!--        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
<!--      </a-dropdown>-->

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
<!--        <template slot="imgSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>-->
<!--          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>-->
<!--        </template>-->
<!--        <template slot="fileSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>-->
<!--          <a-button-->
<!--            v-else-->
<!--            :ghost="true"-->
<!--            type="primary"-->
<!--            icon="download"-->
<!--            size="small"-->
<!--            @click="downloadFile(text)">-->
<!--            下载-->
<!--          </a-button>-->
<!--        </template>-->

        <span slot="action" slot-scope="text, record">
         <a @click="handleDetail(record)">{{$t('button.details')}}</a>
          <a-divider v-if="record.approvalStatus=='00'"  type="vertical" />
          <a-dropdown v-if="record.approvalStatus=='00'">
            <a  class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm :title="$t('tip.makeSureTheReviewIsApproved')" @confirm="() => handlePass(record.id)">
                  <a>{{$t('button.reviewApproved')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                  <a-popconfirm :title="$t('tip.rejected')" @confirm="() => handleFailure(record.id)">
                 <a>{{$t('button.rejected')}}</a>
                </a-popconfirm>
              </a-menu-item>
<!--              <a-menu-item v-if="record.approvalStatus!='30'">-->
<!--                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">-->
<!--                  <a>{{$t('button.delete')}}</a>-->
<!--                </a-popconfirm>-->
<!--              </a-menu-item>-->
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-stl-settle-apply-modal ref="modalForm" @ok="modalFormOk"/>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsStlSettleApplyModal from './modules/EfsStlSettleApplyModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import { putAction } from '@api/manage'

  export default {
    name: "EfsStlSettleApplyList",
    mixins:[JeecgListMixin],
    components: {
      JDictSelectTag,
      EfsStlSettleApplyModal
    },
    data () {
      return {
        description: 'efs_stl_settle_apply管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            slotName: 'tableHeader.farms',
            align:"center",
            dataIndex: 'farmCode_dictText',
            scopedSlots: { title: 'tableHeader.farms'}
          },
          {
            slotName: 'tableHeader.feedingLot',
                        scopedSlots: { title: 'tableHeader.feedingLot'},
            align:"center",
            dataIndex: 'breedBatchCode_dictText'
          },
          {
            slotName: 'tableHeader.grower',
            scopedSlots: { title: 'tableHeader.grower'},
            align:"center",
            dataIndex: 'farmerCode_dictText'
          },
          {
            slotName: 'tableHeader.company',
            scopedSlots: { title: 'tableHeader.company'},
            align:"center",
            dataIndex: 'companyCode'
          },
          // {
          //   title:'申请金额',
          //   align:"center",
          //   dataIndex: 'applyAmount'
          // },
          // {
          //   title:'金额合计',
          //   align:"center",
          //   dataIndex: 'totalAmount'
          // },
          {
            slotName: 'tableHeader.applicant',
            align:"center",
            dataIndex: 'applicant_dictText',
            scopedSlots: { title: 'tableHeader.applicant'}
          },
          // {
          //   title:'申请原因',
          //   align:"center",
          //   dataIndex: 'applyReason'
          // },
          {
             slotName: 'tableHeader.dateOfApplication',
            scopedSlots: { title: 'tableHeader.dateOfApplication'},
            align:"center",
            dataIndex: 'applyTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            slotName: 'tableHeader.lastApprover',
            scopedSlots: { title: 'tableHeader.lastApprover'},
            align:"center",
            dataIndex: 'lastApprover_dictText'
          },
          {
            slotName: 'tableHeader.lastApprovalTime',
            scopedSlots: { title: 'tableHeader.lastApprovalTime'},
            align:"center",
            dataIndex: 'lastApproveTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
            {
                slotName: 'tableHeader.reviewStatus',
            scopedSlots: { title: 'tableHeader.reviewStatus'},
                align:"center",
                dataIndex: 'approvalStatus_dictText'
            },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/settlePolicyApply/efsStlSettleApply/list",
          delete: "/settlePolicyApply/efsStlSettleApply/delete",
          deleteBatch: "/settlePolicyApply/efsStlSettleApply/deleteBatch",
          exportXlsUrl: "/settlePolicyApply/efsStlSettleApply/exportXls",
          importExcelUrl: "settlePolicyApply/efsStlSettleApply/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
        handleFailure(id){
            putAction('/settlePolicyApply/efsStlSettleApply/updateApprovalStatus', {"id": id, "approvalStatus": "40"}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        handlePass(id){
            putAction('/settlePolicyApply/efsStlSettleApply/updateApprovalStatus', {"id": id, "approvalStatus": "30"}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>